/**
 * Runtime function for creating `extendSxProp`.
 *
 * This is a placeholder for the runtime function for replacing the `extendSxProp` in Material UI
 * to reduce bundle size only. DO NOT use it in your codebase.
 */
function extendSxProp(props) {
  return { ...props };
}
export default function createExtendSxProp() {
  return extendSxProp;
}
